$shm_hitalama_map_widget_float_table_resize $mol_view
	width? NaN
	attr *
		^
		title \Изменить ширину столбца
	event *
		^
		pointerdown? <=> start? null
		pointermove? <=> move? null
		pointerup? <=> end? null
		pointercancel? <=> end? null
		lostpointercapture? <=> end? null
		click? <=> suppress? null
		dblclick? <=> suppress? null
